
{
  "label": "Search",
  "placeholders": {
    "search": "Search"
  }
}
